import { useTheme } from '../../theme/ThemeContext';
const STACK_ALIGN_MAP = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  stretch: 'stretch'
};
const STACK_JUSTIFY_MAP = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  between: 'space-between'
};
export const useStackStyles = ({
  gap,
  padding,
  align,
  justify,
  grow,
  overflow,
  maxWidth,
  maxHeight,
  border
}) => {
  const theme = useTheme();
  const SPACING_MAP = {
    '100': theme.spacing['100'],
    '200': theme.spacing['200'],
    '300': theme.spacing['300'],
    '400': theme.spacing['400']
  };
  return Object.assign({
    display: 'flex',
    flexDirection: 'column'
  }, gap && {
    gap: SPACING_MAP[gap]
  }, padding && {
    padding: SPACING_MAP[padding]
  }, align && {
    alignItems: STACK_ALIGN_MAP[align]
  }, justify && {
    justifyContent: STACK_JUSTIFY_MAP[justify]
  }, grow && {
    flex: 1,
    minHeight: 0
  }, overflow && {
    overflowY: overflow
  }, maxWidth !== undefined && {
    maxWidth: `${maxWidth}px`
  }, maxHeight !== undefined && {
    maxHeight: `${maxHeight}px`
  }, border && Object.assign({
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.radius.lg
  }, !overflow && {
    overflow: 'hidden'
  }));
};